<template>
  <e-modal
    :visible="visible"
    :title="title"
    :width="600"
    :loading="loading"
    @close="onClose"
    @ok="onSubmitFun"
  >
    <a-spin tip="Loading..." :spinning="loading">
      <a-form>
        <e-select
          title="角色"
          mode="multiple"
          v-model:value="roleIds"
          :options="roles"
        />
      </a-form>
    </a-spin>
  </e-modal>
</template>

<script>
import { defineComponent, ref } from 'vue'
import form from '@/mixins/form'
import { UserClass } from '@/apis/user'

const api = new UserClass()
export default defineComponent({
  components: {},
  mixins: [form],
  emits: ['ok'],
  setup (props, { emit }) {
    const loading = ref(false)
    const visible = ref(false)
    const title = ref('')

    const onClose = () => {
      loading.value = false
      visible.value = false
    }

    const roles = ref([])
    const roleIds = ref([])
    const userId = ref('')

    return {
      title,
      visible,
      loading,
      roles,
      roleIds,
      userId,

      onClose
    }
  },

  methods: {
    open (data) {
      this.roleIds = data.roleIds
      this.userId = data.id

      this.getRoles()
      this.title = data.name + '设置角色'
      this.visible = true
    },

    async getRoles () {
      const list =
        this.$store.state.data.ALL_ROLES.length > 0
          ? this.$store.state.data.ALL_ROLES
          : await this.$store.dispatch('GetAllRoles').then()

      const curUserRoleTypes = this.$store.state.user.userInfo.roleTypes
      const maxRoleType = Math.max(...curUserRoleTypes)
      const vlist = []
      list.map((e) => {
        if (e.roleType <= maxRoleType) {
          vlist.push({
            label: e.name,
            value: e.id
          })
        }
      })

      this.roles = vlist
    },

    onSubmitFun () {
      this.loading = true
      api.setRoles(this.userId, this.roleIds).then(() => {
        this.$message.success('设置成功')
        this.$emit('ok')
        this.onClose()
      })
    }
  }
})
</script>
